import { render, staticRenderFns } from "./Relieve.vue?vue&type=template&id=66ebf5a1&scoped=true"
import script from "./Relieve.vue?vue&type=script&lang=js"
export * from "./Relieve.vue?vue&type=script&lang=js"
import style0 from "./Relieve.vue?vue&type=style&index=0&id=66ebf5a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ebf5a1",
  null
  
)

export default component.exports